import React from 'react';
const BannerBrand = (props) => {
    return (React.createElement("div", { className: `flex w-full min-width-200 justify-center rounded p-2 ${props.iconContainerClassName}` },
        React.createElement("div", { className: "flex flex-col justify-center" },
            React.createElement("div", { className: "ml-2" },
                React.createElement("i", { className: `fa fa-${props.icon} text-lg ${props.iconClassName}` })))));
};
export default BannerBrand;
